<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="300px"
  >
    <template v-slot:activator="{ on }" />
    <v-card>
      <v-card-title class="text-body-1">
        {{ message }}
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="$emit('update:show', false)"
        >
          {{ $t('ConfirmModal.OK') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    message: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({

  })
}
</script>
